import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import Seo from "@/components/Seo";
import type { Locale } from "@/content/types";

const NotFound = ({ locale }: { locale?: Locale }) => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Seo
        title={`404 | ${t('clinicName')}`}
        description={t('notFoundMessage')}
        path="/404"
        noindex
      />
      <main className="flex min-h-screen items-center justify-center bg-muted">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">{t('notFoundMessage')}</p>
          <a href="/" className="text-primary underline hover:text-primary/90">
            {t('returnHome')}
          </a>
        </div>
      </main>
    </>
  );
};

export default NotFound;
